export const MANAGE_CARD_TOUCHPOINTS = {
  // Card details widget
  CARD_BASIC_WIDGET: 'consumerweb_ucs_card_basic_widget',
  // Card status widget
  ACTION_WIDGET: 'consumerweb_ucs_action_widget',
  // Notification widget
  NOTIFICATION_WIDGET: 'consumerweb_ucs_notification_widget',
}
